import { render, staticRenderFns } from "./FormReports.vue?vue&type=template&id=c45ecf32&scoped=true"
import script from "./FormReports.vue?vue&type=script&lang=js"
export * from "./FormReports.vue?vue&type=script&lang=js"
import style0 from "./FormReports.vue?vue&type=style&index=0&id=c45ecf32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ecf32",
  null
  
)

export default component.exports